<template>
  <section class="empty-box">
      <div>
            <img :src="img">
            <p>{{title}}</p>
      </div>
  </section>
</template>

<script>
export default {
    data(){
        return {
        
        }
    },
    props:{
        img: {
            type:String,
            default: require('@p/assets/images/courseempty.png')
        },
        title: {
            type:String,
            default: '暂无消息'
        },
    },
    methods:{
        backPage () {
            history.back();
        },
        testClick(){

        },
    }
}
</script>

<style scoped lang="less">
    .empty-box{
        // padding-top: 1.066667rem;
        justify-content: center;
        align-items: center;
        display: flex;
        img{
            display: block;
            margin: 0 auto;
            width: 260px;
        }
        p{
            text-align: center;
        }
    }
</style>